import { render, staticRenderFns } from "./KyujitsuToroku.vue?vue&type=template&id=21967846&scoped=true"
import script from "./KyujitsuToroku.vue?vue&type=script&lang=js"
export * from "./KyujitsuToroku.vue?vue&type=script&lang=js"
import style0 from "./KyujitsuToroku.vue?vue&type=style&index=0&id=21967846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21967846",
  null
  
)

export default component.exports